// {
//   "name": "iconic-circle-menu-second.js",
//   "author": "Arham Web Works",
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (!window.APIManager) {
    window.APIManager = {
      youtubeApiReady: false,
      vimeoApiReady: false,
      loadYoutubeAPI() {
        if (window.YT && window.YT.Player) {
          this.youtubeApiReady = true;
          return;
        }
        if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
          const tag = document.createElement('script');
          tag.src = "https://www.youtube.com/iframe_api";
          document.head.appendChild(tag);
          window.onYouTubeIframeAPIReady = () => {
            APIManager.youtubeApiReady = true;
            document.dispatchEvent(new CustomEvent('youtubeApiReady'));
          };
        }
      },
      loadVimeoAPI() {
        if (window.Vimeo) {
          this.vimeoApiReady = true;
          return;
        }
        if (!document.querySelector('script[src="https://player.vimeo.com/api/player.js"]')) {
          const script = document.createElement('script');
          script.src = "https://player.vimeo.com/api/player.js";
          script.onload = () => {
            APIManager.vimeoApiReady = true;
            document.dispatchEvent(new CustomEvent('vimeoApiReady'));
          };
          document.head.appendChild(script);
        }
      }
    };
  }

  if (!window.CircleMenuVideo) {
    class CircleMenuVideo {
      constructor(sectionElement) {
        if (!sectionElement || sectionElement.dataset.initialized === 'true') {
          return;
        }
        this.section = sectionElement;
        this.section.dataset.initialized = 'true';

        this.isSequential = this.section.dataset.sequentialPlay === 'true';
        this.videoItems = Array.from(this.section.querySelectorAll('.circle-menu-item')).filter(item => item.querySelector('video, iframe'));
        this.players = [];
        this.currentIndex = 0;
        this.isHovering = false;
        this.apiCheckInterval = null;

        if (this.videoItems.length === 0) return;

        this.init();
      }

      init() {
        const hasYoutube = this.videoItems.some(item => item.querySelector('iframe[src*="youtube.com"]'));
        const hasVimeo = this.videoItems.some(item => item.querySelector('iframe[src*="vimeo.com"]'));

        if (hasYoutube) APIManager.loadYoutubeAPI();
        if (hasVimeo) APIManager.loadVimeoAPI();
        this.apiCheckInterval = setInterval(() => {
          const youtubeOk = !hasYoutube || APIManager.youtubeApiReady;
          const vimeoOk = !hasVimeo || APIManager.vimeoApiReady;

          if (youtubeOk && vimeoOk) {
            clearInterval(this.apiCheckInterval);
            this.setupPlayers();
          }
        }, 150);
      }

      setupPlayers() {
        this.players = this.videoItems.map((item, index) => {
          const nativeVideo = item.querySelector('video');
          const iframe = item.querySelector('iframe');
          let playerInstance = { item, index };

          if (nativeVideo) {
            playerInstance.type = 'native';
            playerInstance.element = nativeVideo;
            nativeVideo.onended = () => this.onPlayerEnded(playerInstance);
          } else if (iframe) {
            if (iframe.src.includes('youtube.com')) {
              playerInstance.type = 'youtube';
              playerInstance.player = new YT.Player(iframe, {
                events: {
                  'onStateChange': (event) => this.onYouTubeStateChange(event, playerInstance)
                }
              });
            } else if (iframe.src.includes('vimeo.com')) {
              playerInstance.type = 'vimeo';
              playerInstance.player = new Vimeo.Player(iframe);
              playerInstance.player.on('ended', () => this.onPlayerEnded(playerInstance));
            }
          }
          return playerInstance;
        });

        this.addEventListeners();
        if (this.isSequential && this.players.length > 0) {
          this.scheduleNextVideo();
        }
      }

      addEventListeners() {
        this.players.forEach(p => {
          p.item.addEventListener('mouseenter', () => this.handleMouseEnter(p));
          p.item.addEventListener('mouseleave', () => this.handleMouseLeave(p));
        });
      }

      handleMouseEnter(playerInstance) {
        this.isHovering = true;
        this.stopAllVideos();
        this.playVideo(playerInstance);
      }

      handleMouseLeave(playerInstance) {
        this.isHovering = false;
        if (!this.isSequential) {
          this.stopVideo(playerInstance);
        }
      }

      onPlayerEnded(playerInstance) {
        if (this.isSequential && !this.isHovering) {
          this.currentIndex = (playerInstance.index + 1) % this.players.length;
          this.scheduleNextVideo();
        }
      }

      onYouTubeStateChange(event, playerInstance) {
        if (event.data === YT.PlayerState.ENDED) {
          this.onPlayerEnded(playerInstance);
        }
      }

      playVideo(p) {
        if (!p) return;
        try {
          if (p.type === 'native') p.element.play().catch(() => {});
          if (p.type === 'youtube' && p.player?.playVideo) p.player.playVideo();
          if (p.type === 'vimeo' && p.player?.play) p.player.play();
        } catch (e) {
          console.error("Error playing video:", e);
        }
      }

      stopVideo(p) {
        if (!p) return;
        try {
          if (p.type === 'native') p.element.pause();
          if (p.type === 'youtube' && p.player?.pauseVideo) p.player.pauseVideo();
          if (p.type === 'vimeo' && p.player?.pause) p.player.pause();
        } catch (e) {
          console.error("Error stopping video:", e);
        }
      }

      stopAllVideos() {
        this.players.forEach(p => this.stopVideo(p));
      }

      scheduleNextVideo() {
        if (this.isHovering || this.players.length === 0) return;
        this.stopAllVideos();
        const nextPlayer = this.players[this.currentIndex];
        this.playVideo(nextPlayer);
      }
    }

    window.CircleMenuVideo = CircleMenuVideo; 
  }

  const initCircleMenuSections = () => {
    document.querySelectorAll('.iconic-circle-menu-second-section:not([data-initialized="true"])').forEach(section => {
      new CircleMenuVideo(section);
    });
  };

  document.addEventListener('DOMContentLoaded', initCircleMenuSections);
  document.addEventListener('shopify:section:load', (event) => {
    const sectionElement = event.target.querySelector('.iconic-circle-menu-second-section');
    if (sectionElement) {
      sectionElement.dataset.initialized = 'false'; 
      new CircleMenuVideo(sectionElement);
    }
  });
  document.addEventListener('youtubeApiReady', initCircleMenuSections);
  document.addEventListener('vimeoApiReady', initCircleMenuSections);
})();
